import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { configureAxiosClient } from './api/axios-client';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import './index.css';

configureAxiosClient(axios);

(async function () {
  let { default: App } = (await import('./postbuy/PostbuyApp')) as any;
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(<App />);
})();
